import bizNodeModel from '../../bizNodeModel.mjs'

export default bizNodeModel({
    fileId: {
        name: () => '图片内容',
    },

    text: {
        name: () => '图片名称',
        required: () => true,
    },
})
